import styled from '@emotion/styled'

import media from '../../../../styles/media'
import { colors } from '../../../../styles/theme'

const S = {}

S.UserActions = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;

  li {
    transition: background-color 0.1s cubic-bezier(0, 0, 0.25, 1);

    path {
      fill: ${({ lightMode }) => (lightMode ? colors.shark : colors.silver)};
    }

    @media (hover: hover) {
      &:hover {
        background: ${({ lightMode }) =>
          lightMode ? colors.alabaster : colors.woodsmoke};

        path {
          fill: ${({ lightMode }) => (lightMode ? colors.black : colors.white)};
        }
      }
    }
  }

  a {
    display: inline-block;
  }

  .item-queue {
    display: none;

    ${media.sm`
      display: block;
    `};
  }
`

export default S
